import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

const QuestionSectionDeletePopup = ({
  openPopup,
  setOpenPopup,
  sectionOrderId,
  setQuestionsData,
}) => {
  const handleDelete = () => {
    setQuestionsData((prev) => {
      return prev.filter(
        (section) => +section?.sectionOrderId !== +sectionOrderId
      );
    });
  };

  return (
    <div>
      <Dialog
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        id="mars-super-admin-ques-popup"
      >
        <DialogContent>
          <div className="popup-text-container">
            <p>Are you sure you want to delete this section?</p>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            padding: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}
        >
          <button
            className="logout-popup-btn primary-btn mars-admin-popup"
            d
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenPopup(false);
              handleDelete();
            }}
          >
            Yes
          </button>
          <button
            className="logout-popup-btn secondary-btn mars-admin-popup"
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuestionSectionDeletePopup;
